import { ThemeColorToken } from 'theme/config'

/* Figma "Chart/*" ramp in series order (Chart/1000, 400, 100, 300, 500). */
export const CHART_SERIES_TOKENS: ThemeColorToken[] = [
  'chart-series-1',
  'chart-series-2',
  'chart-series-3',
  'chart-series-4',
  'chart-series-5'
]

export const seriesColorAt = (getColor: (token: ThemeColorToken) => string, index: number): string =>
  getColor(CHART_SERIES_TOKENS[index % CHART_SERIES_TOKENS.length])
